import { t } from "i18next";
import { __AppElementType, __BoardTemplateType, enum__BOARD_TEMPLATE_TYPE } from "../../../common/Dictionaries";
import { useDispatch } from "react-redux";
import { action_setBoardConfigAppElementList, action_setBoardConfigElementList, action_setBoardConfigTemplateTypeList } from "../../../reducers/actions/KPI/actions";
import { useEffect } from "react";
import { treeify } from "../../../common/Helpers";
import { getElements } from "../../../services/sKPI/board.service";

const useGetElementsForBoardConfig = (elementsArray, selectedElement, ) => {    
    const dispatch = useDispatch();
    useEffect(()=> {
        const getData = async () => {
            try {
                if (selectedElement.key !== null) {
                    let serviceResponse = await getElements(selectedElement.key);

                    if (serviceResponse.data.succeeded) {
                        const elementList_aux = treeify(serviceResponse.data.data, 'id', "parentId", null, 'code', 'name')

                        dispatch(action_setBoardConfigElementList(elementList_aux))
                    }
                    else {
                        dispatch(action_setBoardConfigElementList([]))
                    }
                }
                else {
                    dispatch(action_setBoardConfigElementList([]))
                }
            }
            catch (error) {
                dispatch(action_setBoardConfigElementList([]))
            }
        }
        
        if (elementsArray === null && selectedElement !== null) {
            getData()
        }

    }, [elementsArray, selectedElement]);
}

const useGetAppElementsForBoardConfig = (appElementsArray, emptyOption) => {    
    const dispatch = useDispatch();
    useEffect(()=> {
        const getData = async () => {
            try {
                const elementList_aux = __AppElementType.map(x => {return {key: x.id, text: t(x.elementName),  title: t(x.elementName)}});
                elementList_aux.unshift({  key: 0, title: emptyOption, text: emptyOption })

                dispatch(action_setBoardConfigAppElementList(elementList_aux))
            }
            catch (error) {
                dispatch(action_setBoardConfigAppElementList([]))
            }
        }
        
        if (appElementsArray === null) {
            getData()
        }

    }, [appElementsArray, emptyOption]);
}

const useGetTemplateTypeForBoardConfig = (templateTypesArray) => {    
    const dispatch = useDispatch();
    useEffect(()=> {
        const getData = async () => {
            try {
                const elementList_aux = __BoardTemplateType.filter(x => x.key !== enum__BOARD_TEMPLATE_TYPE.LANDING && x.key !== enum__BOARD_TEMPLATE_TYPE.PORTFOLIO).map(x => {return {key: x.key, text: t(x.text),  title: t(x.title)}});

                dispatch(action_setBoardConfigTemplateTypeList(elementList_aux))
            }
            catch (error) {
                dispatch(action_setBoardConfigTemplateTypeList([]))
            }
        }
        
        if (templateTypesArray === null) {
            getData()
        }

    }, [templateTypesArray]);
}

export {
    useGetElementsForBoardConfig,
    useGetAppElementsForBoardConfig,
    useGetTemplateTypeForBoardConfig
}